export default __webpack_public_path__ + "static/media/009-energy drink.d8ba46d0.svg";